/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
v3RegistrationApp.controller('confirmEmailCtrl', ['$scope', '$routeParams', '$timeout', '$window', 'DebugHelper', 'V3ActivationTokensResource', function($scope, $routeParams, $timeout, $window, DebugHelper, V3ActivationTokensResource) {
  DebugHelper.register("confirmEmailCtrl", $scope);

  _.assignIn($scope, {
    message: "",
    stateUI: {
      loading: true
    }
  }
  );

  return V3ActivationTokensResource.get({
    activation_token: $routeParams.id,
    activation_token_type: "email_confirmation"
  }
  , function(success) {
      $scope.message = "js.registrations.confirm_email.success";
      return $timeout(function() {
        if ($routeParams.next_path) {
          return $window.location.href = $routeParams.next_path;
        } else {
          return $window.location.href = Packs.iKnowRoutes.v3_dashboard_path();
        }
      }
      , 3000);
    }
  , function(error) {
      $scope.message = "js.registrations.confirm_email.failure";
      return $scope.stateUI.loading = false;
  });
}
]);
